/* tslint:disable */

/**
 */
export class GenericError {
    errorCode?: number;
    message?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/generic-error.ts